import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
export var useOnixCodetableItemsTable = function () {
    var history = useHistory();
    var location = useLocation();
    var formatMessage = useIntl().formatMessage;
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.onix-codetables-items.table.columns.value",
            }),
            key: "value",
            clickable: true,
            onClick: function (row) {
                if (!(row === null || row === void 0 ? void 0 : row.id))
                    return;
                var params = new URLSearchParams(location.search);
                var onixCodetableId = params.get("onixCodetableId");
                var url = "/bragency/onix-codetable-items/edit/".concat(encodeURIComponent(row.id));
                history.push(onixCodetableId ? "".concat(url, "?onixCodetableId=").concat(onixCodetableId) : url);
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.onix-codetables-items.table.columns.description",
            }),
            key: "description",
        },
        {
            name: formatMessage({
                id: "ui-br-agency.onix-codetables-items.table.columns.notes",
            }),
            key: "notes",
        },
    ]; }, [formatMessage, history, location.search]);
    return { columns: columns };
};
